import {withProps} from 'recompose';

// parameters from the route for the timesheet page
export default withProps(({match}) => ({
  date: match.params.date,
  timesheetUser: match.params.user,
  view: match.params.view || 'summary'
}));
